import { Component, OnInit } from '@angular/core';

import moment from 'moment';

import { Grafico } from '../shared/model/chart.model';
import { GraficoSearchParameter } from '../shared/model/search/graficos-search-parameters.model';
import { Prestador } from '../shared/model/prestador.model';
import { PrestadorService } from '../prestador/prestador.service';
import { EstatisticaService } from './estatisticas.service';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './estatisticas.component.html', styleUrls: ['./estatisticas.component.css']})
export class EstatisticasComponent implements OnInit {

  chartDataAnoQtde: Grafico;
  chartDataMesQtde: Grafico;
  chartDataMesValores: Grafico;
  chartDataAnoValores: Grafico;
  chartDataAcumulado: Grafico;

  filters: GraficoSearchParameter;

  listaPrestadores: Prestador[];
  // listaAnos = [];

  constructor(private prestadorService: PrestadorService, private toast: ToastrService, private estatisticaService: EstatisticaService) { }

  ngOnInit() {
    // Inicializar os filtros
    this.filters = new GraficoSearchParameter();

    // Preencher lista de prestadores
    this.getPrestadores();

    this.exibirTodosGraficos();

    // Preencher lista com os anos dos atendimentos
    // this.listaAnos.push({nome: '2019' }, {nome: '2020' }, {nome: '2021' });
  }

  /**
   * Método responsável por setar os valores dos filtros de datas.
   * @param customDateSelectionEvent evento com as datas selecionadas no componente.
   */
  setPeriodDateFilter(customDateSelectionEvent: any) {
    this.filters.dataInicio = moment(customDateSelectionEvent[0]).set({hour: 0, minute: 0, second: 0}).toDate();
    this.filters.dataFim = moment(customDateSelectionEvent[1]).set({hour: 23, minute: 59, second: 59}).toDate();
  }

  // Método responsável por reenderizar todos os gráficos
  filtrarGraficos() {
    this.exibirTodosGraficos();
  }

  // Método responsável por montar o gráfico de valores mensais dos atendimentos.
  private gerarGraficoValoresMensais() {
    this.estatisticaService.buscarValoresAtendimentosMensais(this.filters).subscribe(
      (dados) => {

        // Método para gerar os dados do gráfico acumulado.
        this.gerarGraficoAcumulado(dados);

        // Inicializar o gráfico
        this.chartDataMesValores = new Grafico();

        // Tipo do gráfico
        this.chartDataMesValores.tipo = 'line';

        // Labels do gráfico
        this.chartDataMesValores.labels = dados.map(value => {
          return this.filters.getMes(value.mesAtendimento);
        });

        // Valores plotados nos gráficos.
        this.chartDataMesValores.values = dados.map(value => value.valorTotal);

        this.chartDataMesValores.titulo = 'Valor R$';

        // Definir cores do gráfico
        this.chartDataMesValores.backgroundColor = '#2e74ba';
        this.chartDataMesValores.hoverBackgroundColor = '#0000FF';

        this.chartDataMesValores.tituloEixoY = '';

        this.chartDataMesValores.config = true;
      },
      error => this.toast.error('Erro ao processar o gráfico, tente novamente!')
    );
  }

   // Método responsável por montar o gráfico de valores mensais dos atendimentos.
   private gerarGraficoAcumulado(dados) {
    // Inicializar o gráfico
    this.chartDataAcumulado = new Grafico();

    // Tipo do gráfico
    // this.chartDataAcumulado.tipo = 'line';

    // Labels do gráfico
    this.chartDataAcumulado.labels = dados.map(value => {
      return this.filters.getMes(value.mesAtendimento);
    });

    // Valores plotados nos gráficos.
    let valorAcumulado = 0;
    this.chartDataAcumulado.values = dados.map(value => {
      return valorAcumulado += value.valorTotal;
    });

    this.chartDataAcumulado.titulo = 'Valor R$';

    // Definir cores do gráfico
    this.chartDataAcumulado.backgroundColor = '#2e74ba';
    this.chartDataAcumulado.hoverBackgroundColor = '#0000FF';

    this.chartDataAcumulado.tituloEixoY = '';

    this.chartDataAcumulado.config = true;
  }

  // Método responsável por centralizar chamada de todos os gráficos.
  private exibirTodosGraficos() {
    this.gerarGraficoQuantidadeMensal();
    this.gerarGraficoQuantidadeAnual();
    this.gerarGraficoValoresMensais();
    this.gerarGraficoValoresAnual();
  }

  // Método responsável por formatar o período da data
  getFormatarPeriodoFiltro(): String {
    let format: String = null;
    // se a data inicio e fim estiverem presentes, deve formatar.
    if (this.filters.dataInicio && this.filters.dataFim) {
      format = moment(this.filters.dataInicio).format('DD/MM/YYYY');
      format += '-';
      format += moment(this.filters.dataFim).format('DD/MM/YYYY');
    }
    return format;
  }

  // Método responsável por limpar os filtros
  limparFiltros() {
    this.filters.prestador = null;
    this.filters.dataInicio = null;
    this.filters.dataFim = null;
  }

  // Método responsável por montar o gráfico de valores mensais dos atendimentos.
  private gerarGraficoValoresAnual() {
    this.estatisticaService.buscarValoresAtendimentosAnual(this.filters).subscribe(
      (dados) => {
        // Inicializar o gráfico
        this.chartDataAnoValores = new Grafico();

        // Tipo do gráfico
        this.chartDataAnoValores.tipo = 'bar';

        // Labels do gráfico
        this.chartDataAnoValores.labels = dados.map(value => value.ano);

        // Valores plotados nos gráficos.
        this.chartDataAnoValores.values = dados.map(value => value.valorTotal);

        this.chartDataAnoValores.titulo = 'Valor R$';

        // Definir cores do gráfico
        this.chartDataAnoValores.backgroundColor = '#FFD700';
        this.chartDataAnoValores.hoverBackgroundColor = '#FFFF00';

        this.chartDataAnoValores.tituloEixoY = '';

        this.chartDataAnoValores.config = true;
      },
      error => this.toast.error('Erro ao processar o gráfico, tente novamente!')
    );
  }

  // Método responsável por montar o gráfico de quantidade anual dos atendimentos.
  private gerarGraficoQuantidadeMensal() {
    this.estatisticaService.buscarQuantidadeAtendimentosPorMes(this.filters).subscribe(
      (dados) => {

        this.chartDataMesQtde = new Grafico();

        // Labels do gráfico
        this.chartDataMesQtde.labels = dados.map(value => {
          return this.filters.getMes(value.mesAtendimento);
        });

        // Valores plotados nos gráficos.
        this.chartDataMesQtde.values = dados.map(value => value.quantidade);

        this.chartDataMesQtde.titulo = 'Quantidade';

        // Definir cores do gráfico
        this.chartDataMesQtde.backgroundColor = '#2e74ba';
        this.chartDataMesQtde.hoverBackgroundColor = '#0000FF';

        this.chartDataMesQtde.tituloEixoY = '';
      },
      error => this.toast.error('Erro ao processar o gráfico, tente novamente!')
    );
  }

  // Método responsável por montar o gráfico de quantidade anual dos atendimentos.
  private gerarGraficoQuantidadeAnual() {
    this.estatisticaService.buscarQuantidadeAtendimentosPorAno(this.filters).subscribe(
      (dados) => {

        this.chartDataAnoQtde = new Grafico();

        // Labels do gráfico
        this.chartDataAnoQtde.labels = dados.map(value => value.ano);

        // Valores plotados nos gráficos.
        this.chartDataAnoQtde.values = dados.map(value => value.quantidade);

        this.chartDataAnoQtde.titulo = 'Quantidade';

        // Definir cores do gráfico
        this.chartDataAnoQtde.backgroundColor = '#FFD700';
        this.chartDataAnoQtde.hoverBackgroundColor = '#FFFF00';

        this.chartDataAnoQtde.tituloEixoY = '';
      },
      error => this.toast.error('Erro ao processar o gráfico, tente novamente!')
    );
  }

  // Método responsável por buscar a lista de prestadores.
  private getPrestadores() {
    this.prestadorService.listarTodosPrestadores().subscribe(
      (dados) => this.listaPrestadores = dados,
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }
}
